<template>
<svg version="1.1"
     id="Layer_1" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:svg="http://www.w3.org/2000/svg"
     xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 300 300"
     style="enable-background:new 0 0 300 300;" xml:space="preserve">

<g transform="translate(0,-952.36218)" class="st0">
    <path class="st1" d="M183.7,1015.4c1.1,0.1,2.2,0.6,3.1,1.3l90,75c2.6,2.1,2.9,5.9,0.8,8.4c-0.3,0.3-0.5,0.6-0.8,0.8l-90,75
        c-2.5,2.1-6.3,1.8-8.5-0.8c-0.9-1.1-1.4-2.4-1.4-3.8v-35.8c-2.9,0-4.8-0.1-11.3,0.5c-9.8,0.8-23.1,2.5-38.1,5.8
        c-30,6.6-66.8,19.9-96.7,46c-2.5,2.2-6.3,1.9-8.5-0.6c-1.4-1.6-1.8-3.8-1.2-5.8c25.1-77.3,101.7-108.5,155.7-122.7v-37.4
        c0-3.3,2.6-6,6-6C183.2,1015.3,183.5,1015.4,183.7,1015.4z M189,1034.1v29.2c0,2.7-1.8,5.1-4.5,5.8
        c-47.6,12.1-113.2,37.5-143.1,96.1c27.7-18.8,58-29.5,83.5-35.2c15.6-3.5,29.5-5.2,39.8-6c10.3-0.8,16.4-0.8,18.6-0.8
        c3.2,0.2,5.7,2.8,5.7,6v29.1l74.6-62.1L189,1034.1z"/>
</g>
<g transform="translate(0,-952.36218)">
    <path class="st2" d="M183.7,1000.4c1.1,0.1,2.2,0.6,3.1,1.3l90,90c2.6,2.1,2.9,5.9,0.8,8.4c-0.3,0.3-0.5,0.6-0.8,0.8l-90,90
        c-2.5,2.1-6.3,1.8-8.5-0.8c-0.9-1.1-1.4-2.4-1.4-3.8v-50.8c-2.9,0-4.8-0.1-11.3,0.5c-9.8,0.8-23.1,2.5-38.1,5.8
        c-30,6.6-66.8,19.9-96.7,46c-2.5,2.2-6.3,1.9-8.5-0.6c-1.4-1.6-1.8-3.8-1.2-5.8c25.1-77.3,101.7-108.5,155.7-122.7v-52.4
        c0-3.3,2.6-6,6-6C183.2,1000.3,183.5,1000.4,183.7,1000.4z"/>
</g>
</svg>

</template>

<script>
export default {
    name: 'IconShare',
}
</script>

<style lang="scss" scoped>
</style>